import { peopleTimezoneSettingsTable } from "../database";

/**
 * Fetch timezone settings for the current user
 */
export async function fetchTimezoneSettings(currentOwner: string): Promise<any> {
    return peopleTimezoneSettingsTable.get(currentOwner);
}
